import { DateTime } from "luxon";
import { XCircle } from "react-feather";
import { Button, Modal } from "../../components";
import useLanguage from "../../hooks/language";
import clockIcon from "../../assets/images/clock-icon.svg";
import styles from "./appointment-not-available.module.css";

export default function AppointmentNotAvailableModal({
    appointmentDate,
    visible,
    onClose,
}: {
    appointmentDate: string;
    visible: boolean;
    onClose: () => void;
}): React.ReactElement {
    const { translations, language } = useLanguage();
    const t = translations.appointmentNotAvailableModal;
    const parsedAppointmentDate = appointmentDate
        ? DateTime.fromISO(appointmentDate)
        : null;
    const formattedAppointmentDate =
        parsedAppointmentDate?.isValid === true
            ? parsedAppointmentDate
                  .setLocale(language)
                  .toLocaleString(DateTime.DATETIME_MED)
            : appointmentDate;

    const closeModal = () => {
        if (!visible) return;

        onClose();
    };

    return (
        <Modal
            showHeader={false}
            visible={visible}
            onVisibilityChange={(visible) => {
                if (!visible) closeModal();
            }}
            className={styles["appointment-not-available-modal"]}
        >
            <div className={styles["appointment-not-available-modal__close"]}>
                <button
                    className={
                        styles["appointment-not-available-modal__close-button"]
                    }
                    aria-label={translations.common.close}
                    onClick={closeModal}
                >
                    <XCircle aria-hidden="true" focusable="false" />
                </button>
            </div>

            <div className={styles["appointment-not-available-modal__content"]}>
                <div
                    className={
                        styles[
                            "appointment-not-available-modal__title-container"
                        ]
                    }
                >
                    <div
                        className={
                            styles["appointment-not-available-modal__emoji"]
                        }
                    >
                        🫢
                    </div>

                    <div
                        className={
                            styles["appointment-not-available-modal__overline"]
                        }
                    >
                        {t.overline}
                    </div>

                    <h3
                        className={
                            styles["appointment-not-available-modal__title"]
                        }
                    >
                        {t.title}
                    </h3>

                    <div
                        className={
                            styles[
                                "appointment-not-available-modal__description"
                            ]
                        }
                    >
                        {t.description}
                    </div>
                </div>

                <div
                    className={
                        styles["appointment-not-available-modal__datetime"]
                    }
                >
                    <img
                        src={clockIcon}
                        className={
                            styles[
                                "appointment-not-available-modal__datetime-icon"
                            ]
                        }
                    />
                    {formattedAppointmentDate}
                </div>

                <Button
                    type="primary"
                    className={styles["appointment-not-available-modal__cta"]}
                    onClick={closeModal}
                >
                    {t.cta}
                </Button>
            </div>
        </Modal>
    );
}
